<template>
  <section ref="teamOverview" id="team-overview">
    <div class="row wrapper justify-center">
      <div
          ref="teamNodes"
          v-if="this.isVisible"
          class="shadow-filter animate__bounceInDown py-0 card team-card">
        <div class="card-header">
          <h4 v-text="'Gruppe '.concat((this.count + 1).toString(10))" class="team-number"></h4>
        </div>
        <ol class="card-body no-height row mt-3  mb-0" ref="gruppe">
          <li class="spieler order-1 col-5" v-for="spieler in this.teams[this.count]"
              :key="'team-'+`${Math.random() * 1000}`"
              :class="{
                  'team-leiter': spieler.leader,
              }"
          >
            <img v-if="spieler !== undefined && spieler.img !== '' && spieler.name"
                 class="spieler-icon"
                 alt=""
                 :src="spieler.img"
                 :title="spieler.name"/>

            <img v-else
                 alt=""
                 src="https://www.group24.de/source/img/ansprechpartner/Dummy.jpg"
                 :title="spieler.name"
                 class="spieler-icon"/>
            <p v-text="spieler.name" class="spieler-name"></p>
          </li>
        </ol>
      </div>
      <button @click="this.nextTeam" class="btn btn-next btn-secondary">Nächste Gruppe</button>
    </div>
    <button v-on:click="this.closeOverview" class="btn action btn-secondary">Zurück</button>
  </section>
</template>

<script>
export default {
  name: "TeamOverview",
  props: {
    teamConf: Array
  },
  emits: ['closeOverview'],
  mounted() {
    window.scroll(0, 0);
    this.$nextTick( () => {
      this.checkValues();
      this.changeVisibleState();
      this.count = 0;
    });
  },
  data() {
    return {
      teams: this.teamConf,
      count: 0,
      isVisible: true
    }
  },
  methods: {
    closeOverview() {
      this.$refs.teamOverview.classList.add('animate__backOutRight');
      this.$emit('closeOverview');
    },
    nextTeam() {
      this.count += 1;
      if(this.count >= this.teams.length) {
        this.count = 0;
      }
      this.isVisible = false;
      this.$nextTick( () => {
        this.isVisible = true;
      } );
    },
    checkValues() {
      if (this.teams.length === 0)
        this.$emit('closeOverview');
    },
    changeVisibleState(startIndex = 0, flag = true) {
      return;
      // this function recursively makes all teams visible and invokes the transition / animation
      if (startIndex < this.teamConf.length) {
        setTimeout(() => {
          if (flag) {
            // this.$refs.teamNodes[startIndex].classList.add('animate__bounceInDown');
          } else {
            // this.$refs.teamNodes[startIndex].classList.add('animate__bounceInUp');
          }
          // swap animations
          flag = !flag;
          this.changeVisibleState(startIndex + 1, flag);
        }, 375);
      }
      return;
    }
  },
  computed: {
    filteredTeams() {
      return this.teams; //.filter(teams => !this.isTeamEmpty(teams));
    }
  }
}

</script>
<style>
.wrapper{
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.btn-next {
  padding: 8px 25px;
  width: fit-content;
  position: fixed;
  bottom: -90px;
  right: 00px;
  font-size:1.5rem;
}
.team-leiter{
  order: -1;
}
.team-leiter::after{
  content: "";
  background: url('../assets/krone.png');
  background-size: auto;
  height: 48px;
  width: 48px;
  position: absolute;
  z-index: 10;
  right: 45px;
  background-size: cover;
}
.justify-center {
  justify-content: center !important;
}

#team-overview {
  background-color: rgba(0, 0, 0, 0);
  position: absolute;
  top: 0;
  bottom: 0vh;
  left: 0;
  right: 0;
  padding: 2rem 4rem;
}

.team-card {
  margin-top: 8rem;
  margin-bottom: 2rem;
  border-radius: 10px;
}

.col {
  max-width: 24%;
  flex-basis: 24%;
}

.action {
  position: fixed;
  top: 95vh;
  right: 30px;
}

.card {
  position: relative;
}

.shadow-filter {
  filter: drop-shadow(0 1px 0.25rem rgba(0, 0, 0, .75)) !important;
}

.card-body {
  min-width:55vw;
  width:min-content;
  height: fit-content;
  padding: .75rem .5rem 2rem .5rem;
  justify-content: center;
}

.spieler {
  display: flex;
  align-items: center;
  flex-direction: row;
  margin: 1.5rem 0.8rem .05rem 1rem;
  background: lightgray;
  padding: 10px;
  max-height: 120px;
  border-radius: 8px;
}

.spieler-name {
  text-align: center;
  font-size: 1.65rem;
  margin: 0 0 0 1.5rem;
}

.spieler-icon {
  mix-blend-mode: multiply;
  justify-self: flex-start;
  height: 64px;
  width: 64px;
  border-radius: 50%;
}

.card-header {
  z-index: 55;
  filter: saturate(2);
  display: flex;
  justify-content: center;
  position: absolute;
  left: 50%;
  top: -35px;
  border-radius: 8px !important;
  background: cadetblue;
  /*linear-gradient(to top, rgba(0, 150, 187, 1) 0%, rgba(105, 189, 150, 1) 100%) !important;*/
  color: white;
  font-weight: bolder;
  transform: translateX(-50%);
}

.team-number {
  font-weight: bold;
  margin-bottom: 0;
  line-height: 1.2;
  margin-top: -0.5rem;
  margin-left: -0.1rem;
  padding-top: .3rem;
}

@-webkit-keyframes backOutRight {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }

  20% {
    -webkit-transform: translateX(0px) scale(0.7);
    transform: translateX(0px) scale(0.7);
    opacity: 0.7;
  }

  100% {
    -webkit-transform: translateX(-2000px) scale(0.7);
    transform: translateX(-2000px) scale(0.7);
    opacity: 0.7;
  }
}

@keyframes backOutRight {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }

  20% {
    -webkit-transform: translateX(0px) scale(0.7);
    transform: translateX(0px) scale(0.7);
    opacity: 0.7;
  }

  100% {
    -webkit-transform: translateX(-2000px) scale(0.7);
    transform: translateX(-2000px) scale(0.7);
    opacity: 0.7;
  }
}

.animate__backOutRight {
  animation-iteration-count: 1;
  animation-duration: .7s;
  -webkit-animation-name: backOutRight;
  animation-name: backOutRight;
}

@-webkit-keyframes bounceInDown {
  from,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -3000px, 0) scaleY(3);
    transform: translate3d(0, -3000px, 0) scaleY(3);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, 25px, 0) scaleY(0.9);
    transform: translate3d(0, 25px, 0) scaleY(0.9);
  }

  75% {
    -webkit-transform: translate3d(0, -10px, 0) scaleY(0.95);
    transform: translate3d(0, -10px, 0) scaleY(0.95);
  }

  90% {
    -webkit-transform: translate3d(0, 5px, 0) scaleY(0.985);
    transform: translate3d(0, 5px, 0) scaleY(0.985);
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes bounceInDown {
  from,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -3000px, 0) scaleY(3);
    transform: translate3d(0, -3000px, 0) scaleY(3);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, 25px, 0) scaleY(0.9);
    transform: translate3d(0, 25px, 0) scaleY(0.9);
  }

  75% {
    -webkit-transform: translate3d(0, -10px, 0) scaleY(0.95);
    transform: translate3d(0, -10px, 0) scaleY(0.95);
  }

  90% {
    -webkit-transform: translate3d(0, 5px, 0) scaleY(0.985);
    transform: translate3d(0, 5px, 0) scaleY(0.985);
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.animate__bounceInDown {
  animation-iteration-count: 1;
  animation-duration: .7s;
  -webkit-animation-name: bounceInDown;
  animation-name: bounceInDown;
}

@-webkit-keyframes bounceInUp {
  from,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 3000px, 0) scaleY(5);
    transform: translate3d(0, 3000px, 0) scaleY(5);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0) scaleY(0.9);
    transform: translate3d(0, -20px, 0) scaleY(0.9);
  }

  75% {
    -webkit-transform: translate3d(0, 10px, 0) scaleY(0.95);
    transform: translate3d(0, 10px, 0) scaleY(0.95);
  }

  90% {
    -webkit-transform: translate3d(0, -5px, 0) scaleY(0.985);
    transform: translate3d(0, -5px, 0) scaleY(0.985);
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes bounceInUp {
  from,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 3000px, 0) scaleY(5);
    transform: translate3d(0, 3000px, 0) scaleY(5);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0) scaleY(0.9);
    transform: translate3d(0, -20px, 0) scaleY(0.9);
  }

  75% {
    -webkit-transform: translate3d(0, 10px, 0) scaleY(0.95);
    transform: translate3d(0, 10px, 0) scaleY(0.95);
  }

  90% {
    -webkit-transform: translate3d(0, -5px, 0) scaleY(0.985);
    transform: translate3d(0, -5px, 0) scaleY(0.985);
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.animate__bounceInUp {
  animation-iteration-count: 1;
  animation-duration: .7s;
  -webkit-animation-name: bounceInUp;
  animation-name: bounceInUp;
}
</style>



// WEBPACK FOOTER //
// src/components/TheTeamOverview.vue